/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'
import dashQuestions from 'images/coin-pages/questions/dash.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const dashPage: ICoinPageData = {
  title: 'coin_250',
  description: 'coin_251',
  // description:
  //   'Borrow Dash against Stablecoins.' +
  //   ` Get a stablecoin loan using your DASH coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Dash' }) }} />
  ),
  questionsBlock: {
    image: dashQuestions,
    questions: [
      {
        title: 'coin_252',
        answer: 'coin_253',
      },
      {
        title: 'coin_254',
        answer: 'coin_255',
      },
      {
        title: 'coin_256',
        answer: 'coin_257',
      },
      {
        title: 'coin_258',
        answer: 'coin_259',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Dash (DASH)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_260',
        text: ['coin_263'],
      },
      {
        title: 'coin_261',
        text: ['coin_264', 'coin_265', 'coin_266', 'coin_267', 'coin_268'],
      },
      {
        title: 'coin_262',
        text: ['coin_269', 'coin_270', 'coin_271', 'coin_272', 'coin_273'],
      },
    ],
    ...commonLearnMoreData('Dash (DASH)'),
  },
}
